import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type { SubscriptionOffersQuery } from "~/generated/graphql";
import { GET_MEMBERSHIP_SUBSCRIPTION_OFFERS } from "../providers/operations/membershipSubscriptionOffer";

const useMembershipSubscriptionOffersQuery =
  (): UseQueryResult<SubscriptionOffersQuery> => {
    return useQuery<SubscriptionOffersQuery>(
      GET_MEMBERSHIP_SUBSCRIPTION_OFFERS,
    );
  };

export default useMembershipSubscriptionOffersQuery;
